"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import { WebsocketViewService } from "@/utils/webSocketViewService";
import i18n from "@/lang";
let BrowserProgress = class extends Vue {
  constructor() {
    super(...arguments);
    this.webSocketViewService = WebsocketViewService;
    this.i18N = i18n;
    this.progress = 0;
    this.is_download_complete = false;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.webSocketViewService._ipcEvent.on(
        "event:dynamicBrowser.download.progress",
        (data) => __async(this, null, function* () {
          this.progress = Math.floor(data.data.percentage * 100);
          if (this.progress >= 100) {
            this.is_download_complete = true;
            this.progress = 0;
          }
        })
      );
      this.webSocketViewService._ipcEvent.on(
        "event:dynamicBrowser.download.complete",
        (data) => __async(this, null, function* () {
          this.is_download_complete = true;
          this.progress = 0;
        })
      );
    });
  }
};
BrowserProgress = __decorateClass([
  Component({
    components: {}
  })
], BrowserProgress);
export {
  BrowserProgress as default
};
